import HeadsetMicRoundedIcon from '@mui/icons-material/HeadsetMicRounded';
import { Button, Stack, Typography } from '@mui/material';
import { useIsMobile } from '@/hooks/useResponsive';
import NotificationBanner from '@/components/feedback/notification-banner';
import { appDetails } from '@/utils/configs';
const NeedHelp = () => {
  const isMobile = useIsMobile();
  return isMobile ? <Button href={`tel:${appDetails.supportPhone}`} target='_blank' startIcon={<HeadsetMicRoundedIcon />} fullWidth>
      نیاز به راهنمایی دارم.
    </Button> : <NotificationBanner icon={false}>
      <Stack direction='row' gap='var(--spacing_xs)'>
        <HeadsetMicRoundedIcon sx={{
        color: 'text.text2'
      }} />
        <Stack>
          <Typography color='text.text2' typography='bodyStrong__Wallfund'>
            نیاز به راهنمایی دارید؟
          </Typography>
          <Typography color='text.text2' typography='bodyRegular__Wallfund'>
            پشتیبانی سرمایه‌گذار:{' '}
            <Typography color='text.text2' typography='bodyRegular__Wallfund' component='a' href={`tel:${appDetails.supportPhone}`} sx={{
            textDecoration: 'underline'
          }} dir={'ltr'}>
              {appDetails.supportPhoneLabel}
            </Typography>
          </Typography>
          <Typography color='text.text2' typography='bodyRegular__Wallfund'>
            شنبه تا چهارشنبه، از ساعت ۱۰ تا ۱۷ پاسخگوی تماس شما هستیم.
          </Typography>
        </Stack>
      </Stack>
    </NotificationBanner>;
};
export default NeedHelp;